module.exports = __webpack_public_path__ + "img/small_whale23.132af401.jpg";